import React from 'react';

interface TranscriptEntry {
	speaker: string;
	message: string;
}

interface TranscriptViewerProps {
	transcript?: string;
	height?: string;
	isVoicemail?: boolean;
}

const TranscriptViewer: React.FC<TranscriptViewerProps> = ({
	transcript,
	height = '450px',
	isVoicemail = false,
}) => {
	const parseTranscript = (transcript?: string): TranscriptEntry[] => {
		if (!transcript) {
			return [];
		}

		const lines = transcript.split('\n');
		return lines
			.map((line) => {
				const match = line.match(/^(assistant|user)@\s*(.+)$/);
				if (match) {
					return {
						speaker: match[1] === 'assistant' ? 'AI' : 'Customer',
						message: match[2],
					};
				}
				return null;
			})
			.filter(Boolean) as TranscriptEntry[];
	};

	const transcriptEntries = parseTranscript(transcript);

	return (
		<div className="mb-6">
			<h4 className="font-semibold text-gray-900 mb-3 text-sm tracking-wide">TRANSCRIPT</h4>
			<div
				className="overflow-y-auto bg-gray-50 p-4 rounded-lg border space-y-3"
				style={{ height }}
			>
				{isVoicemail ? (
					<p className="text-sm text-gray-700 italic leading-relaxed">{transcript}</p>
				) : transcriptEntries.length > 0 ? (
					transcriptEntries.map((entry, index) => (
						<div key={index}>
							{entry.speaker === 'AI' ? (
								<div className="flex items-start gap-3">
									<div className="flex-shrink-0">
										<span className="bg-blue-500 text-white text-xs px-2.5 py-1 rounded font-medium">
											AI
										</span>
									</div>
									<div className="bg-blue-100 px-3 py-2.5 rounded-lg max-w-sm">
										<p className="text-sm text-gray-800 leading-relaxed">{entry.message}</p>
									</div>
								</div>
							) : (
								<div className="flex justify-end">
									<div className="bg-white px-3 py-2.5 rounded-lg max-w-sm shadow-sm border">
										<p className="text-sm text-gray-800 leading-relaxed">{entry.message}</p>
									</div>
								</div>
							)}
						</div>
					))
				) : (
					<div className="text-center py-8">
						<p className="text-gray-500">No transcript available</p>
					</div>
				)}
			</div>
		</div>
	);
};

export default TranscriptViewer;
